import script from "./BioIntelligentPart6.vue?vue&type=script&setup=true&lang=js"
export * from "./BioIntelligentPart6.vue?vue&type=script&setup=true&lang=js"

import "./BioIntelligentPart6.vue?vue&type=style&index=0&id=05a78aa9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a78aa9"]])

export default __exports__